import React,{useState, useEffect} from 'react';
import MathJax from '../../components/react-mathjax-preview';
import MathParserUtil from '../../lib/math-parser';
import { TextField ,Checkbox} from 'react-md';
import '../../css/AnswerTypeRPTextBox.css';
import { useDebounce } from 'use-debounce';
import { hasValidValue } from '../../common/functions';



const resizeTextBoxWidth = (textBoxID,callBack,...args) => {
    try{
        let TextBoxSize = (document.getElementById(textBoxID).value.length+1)
        if(TextBoxSize <= 2) {
            const newWidth = TextBoxSize*5;
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }else if (TextBoxSize > 2 && TextBoxSize <= 4  ) {
            const newWidth = TextBoxSize*6.5;
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }else if (TextBoxSize > 4 && TextBoxSize <= 6  ) {
            const newWidth = TextBoxSize*8;
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }else {
            const newWidth = TextBoxSize*9
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }
      

    }catch(e){
        console.error(e);
        
    }finally{
        callBack(...args); 
    }
}
const resizeTextBoxWidthFraction = (textBoxID,callBack,...args) => {
    try{
        const newWidth = (document.getElementById(textBoxID).value.length+1)*6.5;
        if(newWidth < 10){
            document.getElementById(textBoxID).style.width = '50px';
        }else{
            document.getElementById(textBoxID).style.width = `${newWidth*2}px`;   
        } 
    }catch(e){
        console.error(e);
        
    }finally{
        callBack(...args); 
    }
}

const resizeTextBoxWidthPower =(textBoxID,callBack,...args) => {
    
    try{
        let TextBoxSize = (document.getElementById(textBoxID).value.length+1)
        if(TextBoxSize <= 2) {
            const newWidth = TextBoxSize*5;
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }else if (TextBoxSize > 2 && TextBoxSize <= 4  ) {
            const newWidth = TextBoxSize*5.3;
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }else if (TextBoxSize > 4 && TextBoxSize <= 6  ) {
            const newWidth = TextBoxSize*6.3;
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }else {
            const newWidth = TextBoxSize*7
            document.getElementById(textBoxID).style.width = `${newWidth}px`;   
        }
    }catch(e){
        console.error(e);
        
    }finally{
        callBack(...args); 
    }

}
const resizeTextBoxWidthText =(textBoxID,callBack,...args) => {
    
    try{
        const newWidth = (document.getElementById(textBoxID).value.length+1)*8;
        if(newWidth < 10){
            document.getElementById(textBoxID).style.width = '100px';
        }else{
            document.getElementById(textBoxID).style.width = `${newWidth*1.8}px`; 
        }
    }catch(e){
        console.error(e);
        
    }finally{
        callBack(...args); 
    }

}


const AnswerExpSciNotation = ({currentQuestionType, answer_formula,onAnswerChoice,showRPAnswer,currentVariableMap,questionID,onSubmit,onAnswerChoiceDetails, showAnswerResponse, answerCorrect, selectedAnswers, question_attempt, alreadyPickedAnswer}) => {
    const [digitValues,setDigitValues] = useState({});
    const [powerValues,setPowerValues] = useState({});
    const [ansValues,setAnsValues] = useState({});
    const [ansDetailValues,setAnsDetailValues] = useState({});
    const [answerFormula,setAnswerFormula] = useState('');

    const setAnsDetails = (digit,power,key) => {
        let tempAnsValues= {...ansDetailValues};
        tempAnsValues[key] = `${digit} x10^${power}`;
        setAnsDetailValues(tempAnsValues);
        if(onAnswerChoiceDetails){
            onAnswerChoiceDetails({...tempAnsValues})
        }
    }
    
    const extractDigitAndPower = (str) => {
        const regex = /^(\d+)\s*x10\^(\d+)$/;
        const match = str.match(regex);
    
        if (match) {
            const digit = parseInt(match[1], 10);
            const power = parseInt(match[2], 10);
            return { digit, power };
        } else {
            console.error("The input string is not in the expected format.")
            return { digit: null, power: null };
        }
    }

    const onInputElementDigitValueChange = (argValue,ansKey) => {
        let tempDigitValues= {...digitValues};
        let tempAnsValues= {...ansValues};
        tempDigitValues[ansKey] = argValue;
        setDigitValues(tempDigitValues);
        if(!isNaN(argValue)){
            const digit = parseFloat(argValue);
            const power = parseFloat(powerValues[ansKey]);
            if(!isNaN(power) && !isNaN(argValue) &&  argValue !== "" && power !== ""){

                if(answerFormula?.formulaSigFigOption === 1) { //SigFig Validation
                    const SigfigDigit = argValue;
                    const SigfigPower = powerValues[ansKey];
                    const value = digit * (Math.pow(10,power));
                    tempAnsValues[ansKey] = value;
                    
                    setAnsValues(tempAnsValues);
                    onAnswerChoice({...tempAnsValues});
                    setAnsDetails(SigfigDigit,SigfigPower,ansKey)
                } else {

                    const value = digit * (Math.pow(10,power));
                    tempAnsValues[ansKey] = value;
                    
                    setAnsValues(tempAnsValues);
                    onAnswerChoice({...tempAnsValues});
                    setAnsDetails(digit,power,ansKey)
                }

            }
            
        }
        if(argValue === ""){
            tempAnsValues[ansKey] = "";
            setAnsValues(tempAnsValues);
            onAnswerChoice({...tempAnsValues});
            setAnsDetails('','',ansKey)
            
        }
    }

    const onInputElementPowerValueChange = (argValue,ansKey) => {
        let tempPwrValues= {...powerValues};
        let tempAnsValues= {...ansValues};

        tempPwrValues[ansKey] = argValue;
        setPowerValues(tempPwrValues);

        if(!isNaN(argValue)){
            const digit = parseFloat(digitValues[ansKey]);
            const power = parseFloat(argValue);
            
            if(!isNaN(digit) && !isNaN(argValue)  &&  argValue !== "" && digit !== ""){

                if(answerFormula?.formulaSigFigOption === 1) { //SigFig Validation
                    const SigfigDigit = digitValues[ansKey];
                    const SigfigPower = argValue;
                    const value = digit * (Math.pow(10,power));
                    tempAnsValues[ansKey] = value;
                    setAnsValues(tempAnsValues);
                    onAnswerChoice({...tempAnsValues});
                    setAnsDetails(SigfigDigit,SigfigPower,ansKey)
                } else {

                    const value = digit * (Math.pow(10,power));
                    tempAnsValues[ansKey] = value;
                    setAnsValues(tempAnsValues);
                    onAnswerChoice({...tempAnsValues});
                    setAnsDetails(digit,power,ansKey)
                }
            }

        }
        if(argValue === ""){
            tempAnsValues[ansKey] = "";
            setAnsValues(tempAnsValues);
            onAnswerChoice({...tempAnsValues});
            setAnsDetails('','',ansKey)
        }
    }

    useEffect(()=>{
        console.debug("selectedAnswers >>?? AnswerExpSciNotation", selectedAnswers, question_attempt)
        if (selectedAnswers && typeof selectedAnswers === 'object') {
            let tempDigitValues = {};
            let tempPowerValues = {};
            const regex = /(\d*\.?\d+)\s*x10\^(\d+)/;

            Object.keys(selectedAnswers).forEach(key => {
                let text = selectedAnswers[key];
                if (typeof text !== 'string') {
                    text = MathParserUtil.convertToScientificForm(text);
                }
                let match = text.match(regex);
                if (match) {
                    if (match && match.length) {
                        if (match[1]) {
                            let digitValue = match[1];
                            tempDigitValues[key] = digitValue;
                        }
                        if (match[2]) {
                            let powerValue = match[2];
                            tempPowerValues[key] = powerValue;
                        }
                    }
                }
            })

            setDigitValues(tempDigitValues);
            setPowerValues(tempPowerValues)
        } else {
            setDigitValues({});
            setPowerValues({}); 
        }
        setAnsValues({})
        setAnswerFormula(answer_formula);
    },[questionID,answer_formula, question_attempt, alreadyPickedAnswer]);
    
    const onKeyDownEvent = (event) => {
        
        if (event.keyCode === 13) {
            //Masking the onSubmit because student keep pressing enter and the wheel goes crazy
            //Fix for bug id https://gitlab.com/ontoborn/es-2.0/-/issues/15
            //onSubmit();
            //TODO: Call onSubmit of only once. Make sure to test pressing and holding the enter key.
        }
        
    }
    

    let InputElementDigit =(props) =>  <TextField {...props} />
 
                            
    const {formula,formulaMap,formulaOneEvaluateOption,addFormulaSwitch,formulaPrefix,formulaSuffix} = answerFormula;    
    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(formula);                                        
   
    console.debug("powerValues, digitValues formulaTextArray>>>", powerValues, digitValues, formulaTextArray)
    
    if(answerFormula && formulaMap){
            if(showRPAnswer === true){
                
                    InputElementDigit = formulaTextArray.map((ansSegment,index) =>{
                                                            
                                            if(formulaMap.get(`{{${ansSegment}}}`)){
                                                const correctAnswer = MathParserUtil.computeAnswer(ansSegment,currentVariableMap);
                                                const validationMode = formulaMap?.get(`{{${ansSegment}}}`)?.validationMode;
                                                let expValue;
                                                if(answerFormula?.formulaSigFigOption === 1){
                                                    // SigFig calculation
                                                    const significantDigit =  parseInt(answerFormula?.formulaSigFigOptionValue, 10) || 1;;
                                                    expValue = correctAnswer.toExponential(significantDigit-1);
                                                }else if(validationMode === "precision"){
                                                    const {answerPrecision} = formulaMap.get(`{{${ansSegment}}}`);
                                                    const answerPrecisionInt = parseInt(answerPrecision,10);
                                                    expValue = correctAnswer.toExponential(answerPrecisionInt-1);
                                                }else{
                                                    expValue = correctAnswer.toExponential(2);
                                                } 

                                                const sciValue = expValue.toString().replace('e','\\times 10^').replace('10^+','10^');
                                                const powerExp = sciValue.substr(sciValue.indexOf('10^'), sciValue.length);
                                                const powerDigit = sciValue.substr(sciValue.indexOf('10^')+3, sciValue.length);
                                                const replacedText = `10^{${powerDigit}}`
                                                const sciText = sciValue.replace(powerExp,replacedText);
                                                return  <div style={{display:"flex",alignItems:"center",width:"max-content"}}>
                                                            <div style={{fontSize:"16px",fontWeight:"400"}}>

                                                                  {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}              
                                                            </div>
                                                            <div>
                                                                <MathJax math={`$$ ${sciText} $$`} className="rp-check-answer-math-jax rp-answer-math-jax rp-ft-input rp-fr-showans" />
                                                            </div>
                                                            <div style={{fontSize:"16px",fontWeight:"400"}}>
                                                                {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''}             
                                                            </div> 

                                                        </div>
                                            }else{
                                                if(ansSegment && ansSegment.length > 0 && ansSegment !== ' '){ 
                                                    return  <div style={{display:"flex",alignItems:"center"}}>
                                                                {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}
                                                                <MathJax math={`${ansSegment}`} className="rp-check-answer-math-jax rp-answer-math-jax rp-ft-input rp-fr-showans" /> 
                                                                {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''}
                                                            </div>
                                                } else
                                                    return ""
                                            } 
                                        });

                
                
                
                
                
                return <div>
                     { currentQuestionType === 3 &&  !(formulaOneEvaluateOption === 0 && !addFormulaSwitch) ? 
                        <div style={{display:"flex"}} >
                                                                
                        <div>
                                <div  className="rp-fr-showans mt-4"  style={{display:"flex",width:"max-content"}}>
                                
                                    <div style={{fontSize:"16px",marginRight:"5px",marginTop:"20px",fontWeight:"400",display:"flex"}}>
                                    Answer is  
                                    <div style={{marginLeft:"10px"}}>

                                    {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}                
                                    </div>
                                    </div> 
                                    
                                    <div style={{fontSize:"16px",marginTop:"7px"}}>
                                        <MathJax math={`$$ ${MathParserUtil.CheckAnswerVectorRangeForScitificNotation(answer_formula,currentVariableMap)}$$ `} className="rp-answer-math-jax rp-ft-input rp-fr-showans" />
                                    </div>
                                    <div style={{fontSize:"16px",marginLeft:"5px",marginTop:"20px",fontWeight:"400"}}>
                                    {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''}                
                                    </div> 
                                </div> 
                            </div>     
                        </div> :
                         <div className={`rp-text-box ${showAnswerResponse ? (answerCorrect ? 'rp-check-answer rp-text-box-correct' : 'rp-text-box-incorrect') : ''}`}> 
                            {InputElementDigit}
                        </div>
                    }
                </div> 
            }
            return <div>
            <div className='mb-2'>Fill in the below boxes using scientific notation:</div>
            <div > 
                <div className={`scifi-container ${showAnswerResponse ? (answerCorrect ? 'rp-text-scifibox-correct' : 'rp-text-box-incorrect') : ''}`}>
                    <div className="scifi-prefix" style={{fontSize:"14px",marginRight:"7px",marginTop:"12px",fontWeight:"500"}}>
                        {formulaPrefix != "" ? <MathJax  textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaPrefix} /> : ''}                
                    </div> 
                    <div  className="scifi-textbox">
                    {
                                formulaTextArray.map((ansSegment,index) =>{
                                    console.log("rp-scifi-textbox",digitValues[ansSegment])
                                    if(formulaMap.get(`{{${ansSegment}}}`)){
                                        return <React.Fragment>
                                                     {
                                                        digitValues[ansSegment] ?

                                                        <TextField  
                                                            className={`rp-scifi-textbox ${showAnswerResponse ? (answerCorrect ? 'rp-scifi-textbox-correct' : 'rp-scifi-textbox-incorrect') : ''}`}
                                                            id={`rp-textbox-digit-${index}`}
                                                            key={`rp-textbox-digit-${index}-${questionID}`}
                                                            value={digitValues[ansSegment]?digitValues[ansSegment]:""}
                                                            onChange={(value) =>  resizeTextBoxWidth(`rp-textbox-digit-${index}`,onInputElementDigitValueChange,value,ansSegment)}
                                                            size={2}
                                                            fullWidth={false}
                                                            aria-label={`Significand for scientific notation answer ${index + 1}`}
                                                            onKeyDown={onKeyDownEvent}
                                                            autoComplete="off"
                                                            style={{fontFamily: "MathJax_Main !important"}}
                                                        
                                                        /> :
                                                            <TextField  
                                                            className="rp-scifi-textbox-temp"
                                                            id={`rp-textbox-digit-${index}`}
                                                            key={`rp-textbox-digit-${index}-${questionID}`}
                                                            value={digitValues[ansSegment]?digitValues[ansSegment]:""}
                                                            onChange={(value) =>  resizeTextBoxWidth(`rp-textbox-digit-${index}`,onInputElementDigitValueChange,value,ansSegment)}
                                                            size={2}
                                                            fullWidth={false}
                                                            aria-label={`Significand for scientific notation answer ${index + 1}`}
                                                            onKeyDown={onKeyDownEvent}
                                                            autoComplete="off"
                                                            style={{fontFamily: "MathJax_Main !important", minWidth:'25px'}}
                                                        
                                                        />
                                                     }
                                                </React.Fragment>
                                    }else{
                                        if(ansSegment && ansSegment.length > 0)
                                            return <td style={{fontSize:'14px', paddingTop:'15px'}}>{React.createElement(MathJax,{className: "rp-ft-mathjax", disableKeyboardNavigation: true, "math":ansSegment})}</td>
                                        else
                                            return <td></td>
                                    } 
                                })
                            }
                    </div>
                    <div  className="scifi-textbox-power">
                    x {" "} 10
                    </div>
                    <div  className="scifi-scifibox-exponent">
                    {                    
                                formulaTextArray.map((ansSegment,index) =>{
                                    if(formulaMap.get(`{{${ansSegment}}}`)){
                                        return  <React.Fragment>
                                                    {
                                                        powerValues[ansSegment] ?

                                                        <TextField 
                                                           className={`rp-scifi-textbox-exponent ${showAnswerResponse ? (answerCorrect ? 'rp-scifi-textbox-correct' : 'rp-scifi-textbox-incorrect') : ''}`}
                                                            id={`rp-textbox-power-${index}`}
                                                            key={`rp-textbox-power-${index}-${questionID}`}
                                                            onChange={(value) => resizeTextBoxWidthPower(`rp-textbox-power-${index}`,onInputElementPowerValueChange,value,ansSegment)}
                                                            value={powerValues[ansSegment]?powerValues[ansSegment]:""}
                                                            fullWidth={false}
                                                            aria-label={`Exponent for scientific notation answer ${index + 1}`}
                                                            onKeyDown={onKeyDownEvent}
                                                            autoComplete="off" 
                                                            style={{fontFamily: "MathJax_Main !important"}}

                                                        /> :
                                                        <TextField className="rp-scifi-textbox-exponent-temp"
                                                            id={`rp-textbox-power-${index}`}
                                                            key={`rp-textbox-power-${index}-${questionID}`}
                                                            onChange={(value) => resizeTextBoxWidthPower(`rp-textbox-power-${index}`,onInputElementPowerValueChange,value,ansSegment)}
                                                            value={powerValues[ansSegment]?powerValues[ansSegment]:""}
                                                            fullWidth={false}
                                                            aria-label={`Exponent for scientific notation answer ${index + 1}`}
                                                            onKeyDown={onKeyDownEvent}
                                                            autoComplete="off" 
                                                            style={{fontFamily: "MathJax_Main !important"}}

                                                        />
                                                    }
                                                </React.Fragment>
                                    }
                                })
                            }
                    </div>
                    <div style={{fontSize:"14px",marginLeft:"7px",marginTop:"15px",fontWeight:"500"}} className="formulaSuffixDiv">
                        {formulaSuffix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaSuffix} /> : ''}                
                        </div> 
                </div>
        </div>
        </div>
        }else{
            return null;
        }
}



const AnswerDecimalNotation = ({currentQuestionType, answer_formula,onAnswerChoice,showRPAnswer,currentVariableMap,questionID,onSubmit,onAnswerChoiceDetails, showAnswerResponse, answerCorrect, selectedAnswers,answerFormat, question_attempt, alreadyPickedAnswer}) => {
    const [values,setValue] = useState({});
    const [finalValue] = useDebounce(values, 500)
    const {formula,formulaMap,formulaPrefix,formulaSuffix,formulaOneEvaluateOption,addFormulaSwitch,formulaSigFigOption,formulaSigFigOptionValue} = answer_formula;

    useEffect(() => {
        if (hasValidValue(finalValue)) {
            console.debug("finalValue>>>", finalValue)
            onAnswerChoice(finalValue);
            onAnswerChoiceDetails({...finalValue})
        }
    }, [finalValue])

    const onInputValueChange = (newValue,ansKey) => {
        let tempValues= {...values};
        tempValues[ansKey] = newValue;
        setValue(tempValues);
        
    }

    useEffect(()=>{
        console.debug("selectedAnswers >>?? AnswerDecimalNotation", selectedAnswers, question_attempt)
        if (selectedAnswers && typeof selectedAnswers === 'object') {
            setValue(selectedAnswers)
        } else {
            setValue({});
        }
        
    },[questionID,answer_formula, question_attempt, alreadyPickedAnswer]);

    const onKeyDownEvent = (event) => {
        
        if (event.keyCode === 13) {
            //Masking the onSubmit because student keep pressing enter and the wheel goes crazy
            //Fix for bug id https://gitlab.com/ontoborn/es-2.0/-/issues/15
            //onSubmit();
            //TODO: Call onSubmit of only once. Make sure to test pressing and holding the enter key.
        }
        
    }
    

    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(formula);
    console.debug("formulaTextArray", formulaTextArray, formulaMap, values)
    
    
    if(formulaTextArray && formulaTextArray.length > 0 && formulaMap ){
        return <div className="mt-0 mb-2"> 
                    <div className='mb-2'>Fill in the input box:</div>
                    {
                        formulaTextArray.map((ansSegment,index) =>{
                            
                            if(formulaMap.get(`{{${ansSegment}}}`)){
                                if(showRPAnswer === true){
                                    if(currentVariableMap.get(ansSegment) !== undefined && currentVariableMap.get(ansSegment).type === 'LIST'){
                                        const key = currentVariableMap.get(ansSegment).value;
                                        const formulaObject = formulaMap.get(`{{${ansSegment}}}`);
                                        const correctAnswer = formulaObject.listValues[key];
                                        return <span className="rp-fr-showans" key={`correctAnswer-${index}`} style={{display:"flex",width:"max-content"}}>
                                                 <div style={{marginRight:"10px"}}>
                                                    {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}  
                                                </div>
                                                {correctAnswer}
                                                <div style={{marginLeft:"10px"}}>
                                                     {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''} 
                                                </div> 
                                            </span>
                                    }else{
                                        const formulaObject = formulaMap.get(`{{${ansSegment}}}`);
                                    
                                        let correctAnswer = MathParserUtil.computeAnswer(ansSegment,currentVariableMap);
                                        if (currentQuestionType === 1 && answerFormat === 6) { // Enotation
                                            if (formulaSigFigOption === 1) { //SigFig Validation
                                                const significantDigit =  parseInt(formulaSigFigOptionValue, 10) || 1;
                                                correctAnswer = Number(correctAnswer).toExponential(significantDigit-1);
                                                return (
                                                    <span className="rp-fr-showans" key={`correctAnswer-${index}`} style={{display:"flex",width:"max-content"}}>
                                                            <div style={{marginRight:"10px"}}>
                                                                {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}  
                                                            </div>
                                                            {correctAnswer}
                                                            <div style={{marginLeft:"10px"}}>
                                                                {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''} 
                                                            </div> 
                                                    </span>
                                                );
                                            }
                                            correctAnswer = Number(correctAnswer).toExponential();
                                            if (formulaObject.validationMode === "precision") {
                                                const { answerPrecision } = formulaObject;
                                                const answerPrecisionInt = parseInt(answerPrecision, 10);                            
                                                correctAnswer = Number(correctAnswer).toExponential(answerPrecisionInt);
                                                return (
                                                    <span className="rp-fr-showans" key={`correctAnswer-${index}`}>
                                                        {correctAnswer}
                                                    </span>
                                                );
                                            }
                                        }
                                        if (formulaSigFigOption === 1) { //SigFig Validation
                                            const significantDigit =  parseInt(formulaSigFigOptionValue, 10) || 1;
                                            return <span className="rp-fr-showans" key={`correctAnswer-${index}`} style={{display:"flex",width:"max-content"}}>
                                                        <div style={{marginRight:"10px"}}>
                                                            {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}  
                                                        </div>
                                                            {parseFloat(correctAnswer).toPrecision(significantDigit)}
                                                        <div style={{marginLeft:"10px"}}>
                                                            {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''} 
                                                        </div>
                                                </span>
                                        }else if(formulaObject.validationMode === "precision"){
                                            const {answerPrecision} = formulaObject;
                                            const answerPrecisionInt = parseInt(answerPrecision,10);
                                            return <span className="rp-fr-showans" key={`correctAnswer-${index}`} style={{display:"flex",width:"max-content"}}>
                                                 <div style={{marginRight:"10px"}}>
                                                    {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}  
                                                </div>
                                                     {parseFloat(correctAnswer).toPrecision(answerPrecisionInt)}
                                                <div style={{marginLeft:"10px"}}>
                                                     {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''} 
                                                </div>
                                                </span>
                                        }
                                        
                                        return <div>
                                        
                                          { currentQuestionType === 3 &&  !(formulaOneEvaluateOption === 0 && !addFormulaSwitch) ? 
                                           <div style={{display:"flex"}}>
                                           
                                                <div>
                                                        <div  className="rp-fr-showans mt-4" key={`correctAnswer-${index}`} style={{display:"flex",width:"max-content"}}>
                                                        
                                                            <div style={{fontSize:"14px",marginRight:"5px",marginTop:"7px",fontWeight:"400",display:"flex"}}>
                                                            Answer is  
                                                            <div style={{marginLeft:"10px"}}>

                                                            {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}                
                                                            </div>
                                                            </div> 
                                                            
                                                            <div style={{fontSize:"14px",marginTop:"7px"}}>
                                                            {MathParserUtil.CheckAnswerVectorRange(answer_formula,currentVariableMap)} 
                                                            </div>
                                                            <div style={{fontSize:"14px",marginLeft:"5px",marginTop:"7px",fontWeight:"400"}}>
                                                            {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''}                
                                                            </div> 
                                                        </div> 
                                                  </div>     
                                             </div> 
                                            :
                                             <span className="rp-fr-showans" key={`correctAnswer-${index}`} style={{display:"flex",width:"max-content"}}>
                                                <div style={{marginRight:"10px"}}>
                                                    {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}  
                                                </div>
                                                 {correctAnswer}
                                                <div style={{marginLeft:"10px"}}>
                                                     {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''} 
                                                </div>
                                              
                                                </span> 
                                          }
                                           
                                             
                                          
                                        </div>
                                    }
                                    
                                }
                                return <div style={{display:"flex"}}>
         
                                        <div style={{fontSize:"14px",marginRight:"2px",marginTop:"7px",fontWeight:"400"}}>
                                            {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}                
                                        </div> 
                                        <TextField
                                                    id={`ans-rp-txt-${index}`}
                                                    key={`ans-rp-txt-${index}-${questionID}`}
                                                    className={`rp-ft-input ${showAnswerResponse ? (answerCorrect ? "rp-ft-input-correct" : "rp-ft-input-incorrect") :""}`}
                                                    onChange={value=>resizeTextBoxWidthText(`ans-rp-txt-${index}`,onInputValueChange,value,ansSegment)}
                                                    value={values[ansSegment]?values[ansSegment]:""}
                                                    size={3}
                                                    fullWidth={false}
                                                    style={{marginTop:"10px !important",height:"30px"}}
                                                    onKeyDown={onKeyDownEvent}
                                                    autoComplete="off"
                                                /> 
                                
                                             <div style={{fontSize:"14px",marginLeft:"2px",marginTop:"7px",fontWeight:"400"}}>
                                              {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''}                
                                            </div> 
                                </div> 
                                
                               
                            }else{
                                
                                if(ansSegment && ansSegment.length > 0)
                                    return React.createElement(MathJax,{className: "rp-ft-mathjax","math":ansSegment,"key":index});
                                else
                                    return ""
                            } 
                        })
                    }
                </div>
    }
    else{
        return null;
    }

    
}


const Fraction = ({answer_formula,onAnswerChoice,showRPAnswer,currentVariableMap,questionID,onSubmit,onAnswerChoiceDetails, showAnswerResponse, answerCorrect, selectedAnswers, question_attempt, alreadyPickedAnswer})=>{
    const {formula,formulaMap, formulaPrefix,formulaSuffix} = answer_formula;
    const [signValues,setSignValues] = useState({});
    const [numValues,setNumValues] = useState({});
    const [denValues,setDenValues] = useState({});
    const [ansValues,setAnsValues] = useState({});
    const [ansDetailValues,setAnsDetailValues] = useState({});

    const setAnsDetails = (n,d,s,key) => {
        let tempAnsValues= {...ansDetailValues};
        if(s)
            tempAnsValues[key] = `-${n}/${d}`;
        else
            tempAnsValues[key] = `${n}/${d}`;
        setAnsDetailValues(tempAnsValues);
        if(onAnswerChoiceDetails){
            onAnswerChoiceDetails({...tempAnsValues})
        }
    }

    const onInputElementNumValueChange = (argValue,ansKey) => {
        let tempNumValues= {...numValues};
        let tempAnsValues= {...ansValues};
        tempNumValues[ansKey] = argValue;
        setNumValues(tempNumValues);
        if(!isNaN(argValue)){
            const num = parseFloat(argValue);
            const den = parseFloat(denValues[ansKey]);
            const sign = signValues[ansKey];
            if(!isNaN(den) && !isNaN(argValue) &&  argValue !== "" && den !== ""){
                const value = num / den;
                tempAnsValues[ansKey] = sign?-1*value:value;
                setAnsValues(tempAnsValues);
                onAnswerChoice({...tempAnsValues});
                setAnsDetails(num,den,sign,ansKey)
            }
            
        }
        if(argValue === ""){
            tempAnsValues[ansKey] = "";
            setAnsValues(tempAnsValues);
            onAnswerChoice({...tempAnsValues});
            setAnsDetails('','','',ansKey);
        }
    }

    const onInputElementDenValueChange = (argValue,ansKey) => {
        let tempDenValues= {...denValues};
        let tempAnsValues= {...ansValues};

        tempDenValues[ansKey] = argValue;
        setDenValues(tempDenValues);

        if(!isNaN(argValue)){
            const num = parseFloat(numValues[ansKey]);
            const den = parseFloat(argValue);
            const sign = signValues[ansKey];
            
            if(!isNaN(num) && !isNaN(argValue)  &&  argValue !== "" && num !== ""){
                const value = num / den;
                tempAnsValues[ansKey] = sign?-1*value:value;
                setAnsValues(tempAnsValues);
                onAnswerChoice({...tempAnsValues});
                setAnsDetails(num,den,sign,ansKey)
            }

        }
        if(argValue === ""){
            tempAnsValues[ansKey] = "";
            setAnsValues(tempAnsValues);
            onAnswerChoice({...tempAnsValues});
            setAnsDetails('','','',ansKey);
        }
    }

    const onInputElementSignValueChange = (argValue,ansKey) => {
        
        let tempSignValues= {...signValues};
        let tempAnsValues= {...ansValues};

        tempSignValues[ansKey] = argValue;
        setSignValues(tempSignValues);

        if(!isNaN(argValue)){
            const num = parseFloat(numValues[ansKey]);
            const den = parseFloat(denValues[ansKey]);
            
            
            if(!isNaN(num) && !isNaN(den)  &&  den !== "" && num !== ""){
                const value = num / den;
                tempAnsValues[ansKey] = argValue?-1*value:value;
                setAnsValues(tempAnsValues);
                onAnswerChoice({...tempAnsValues});
                setAnsDetails(num,den,argValue,ansKey)
            }

        }
        if(argValue === ""){
            tempAnsValues[ansKey] = "";
            setAnsValues(tempAnsValues);
            onAnswerChoice({...tempAnsValues});
            setAnsDetails('','','',ansKey);
        }
    }
    

    useEffect(()=>{
        console.debug("selectedAnswers >>?? Fraction", selectedAnswers, question_attempt)
        if (selectedAnswers && typeof selectedAnswers === 'object') {
            let tempNumValues = {};
            let tempDenValues = {};
            Object.keys(selectedAnswers).forEach(key => {
                let text = selectedAnswers[key];
                if (text) {
                    if (typeof text !== 'string') {
                        text = MathParserUtil.decimalToFraction(text);
                    }
                    let values = text.split("/")
                    if (values && values.length) {
                        if (values[0]) {
                            tempNumValues[key] = values[0]
                        }
                        if (values[1]) {
                            tempDenValues[key] = values[1]
                        }
                    }
                }
            })
            setNumValues(tempNumValues);
            setDenValues(tempDenValues);
        } else {
            setNumValues({});
            setDenValues({});
        }
        
        setAnsValues({});
        setSignValues({});
        return(()=>{
            setSignValues(false);
        })
    },[questionID,answer_formula, question_attempt, alreadyPickedAnswer]);

    
    const buildFractionTableData = (formulaTextArray,formulaMap) =>{
        let data = [];

        for(let index = 0; index < formulaTextArray.length ; index++){
                let ansSegment = formulaTextArray[index];
                let fractionValue = null;
                if(showRPAnswer && formulaMap.get(`{{${ansSegment}}}`)){
                    //Get the Answer Here
                    const correctAnswer = MathParserUtil.computeAnswer(ansSegment,currentVariableMap);
                    fractionValue = MathParserUtil.getFractionValue(correctAnswer);
                    console.debug("ansSegment,currentVariableMap", ansSegment,currentVariableMap, correctAnswer, fractionValue);
                }
                let tempColumn = {};
                tempColumn['row0'] = <td key={`rp-sign-row0-${index}`}></td>;
                if(formulaMap.get(`{{${ansSegment}}}`)){
                    
                    tempColumn['row1'] = <td style={{lineHeight:'0',paddingTop:'30px'}}  key={`rp-sign-row2-${index}`}>
                                            {
                                                showRPAnswer?
                                                    fractionValue.s === -1?<span style={{fontSize:'20px',padding:'0px',marginLeft:"3px"}}>&#8212;</span>:''
                                                :
                                                <td style={{lineHeight:'0'}} key={`rp-sign-row2-${index}`}>
                                                    {signValues[ansSegment]?<span style={{fontSize:'20px',padding:'0px',marginLeft:"3px"}}>&#8212;</span>:''}
                                                </td>
                                            }
                                            
                                        </td>;
                }else{
                    tempColumn['row1'] = <td key={`rp-sign-row2-${index}`}></td>
                }
                tempColumn['row2'] = <td key={`rp-sign-row1-${index}`}></td>;
                tempColumn['row3'] = <td key={`rp-sign-row3-${index}`}></td>;  
                data.push(tempColumn);                   
            

            tempColumn = {};

            if(formulaMap.get(`{{${ansSegment}}}`)){
                tempColumn['row0'] =  <td key={`rp-textbox-value-row0-${index}`}>
                                            {
                                                !showRPAnswer?
                                                <Checkbox
                                                    defaultChecked ={false}
                                                    id={`rp-sign-row2-${index}`}
                                                    name="Enable negative sign"
                                                    onChange={(checked) => {
                                                        onInputElementSignValueChange(checked,ansSegment)
                                                    }}
                                                    checked={signValues[ansSegment]?signValues[ansSegment]:false}
                                                    disabled={showAnswerResponse ? true :false }
                                                    className='rp-fraction-checkbox'
                                                    label={
                                                        <div style={{fontFamily:'sans-serif'}}>
                                                            Add a negative sign
                                                        </div>
                                                    }
                                                    key={`rp-sign-key-${index}-${questionID}`} 
                                                />:""}
                </td>;
                tempColumn['row1'] =  <td key={`rp-textbox-value-row1-${index}`} style={ { borderBottom: showRPAnswer ? '1px solid black' : '' } }  >
                                            
                                            {
                                                showRPAnswer?
                                                    fractionValue.n
                                                :
                                                <TextField  id={`rp-textbox-value-row1-${index}`} 
                                                key={`rp-textbox-value-row1-${index}-${questionID}`} 
                                                className="rp-ft-input rp-fr-fraction rp-fr-num" 
                                                style={{display:"inline-block", minWidth:"50px"}}
                                                size={2}
                                                fullWidth={false}
                                                disabled={showAnswerResponse ? true :false }
                                                onChange={(value) => {resizeTextBoxWidthFraction(`rp-textbox-value-row1-${index}`,onInputElementNumValueChange,value,ansSegment)}}
                                                value={numValues[ansSegment]?numValues[ansSegment]:""}
                                                autoComplete="off"
                                                />
                                            }
                                        </td>;
                tempColumn['row2'] = <td key={`rp-textbox-value-row2-${index}`} style={{padding:'0px',display:'none'}}>
                                       <div></div>
                                    </td>; 
                tempColumn['row3'] =  <td  key={`rp-textbox-value-row3-${index}`}>
                                            
                                            {
                                                showRPAnswer?
                                                    fractionValue.d
                                                :
                                                <TextField  
                                                    id={`rp-textbox-value-row3-${index}`} 
                                                    key={`rp-textbox-value-row3-${index}-${questionID}`} 
                                                    className="rp-ft-input rp-fr-fraction rp-fr-dnm" 
                                                    style={{display:"inline-block", minWidth:"50px"}}
                                                    size={2}
                                                    disabled={showAnswerResponse ? true :false }
                                                    fullWidth={false}
                                                    onChange={(value) => {resizeTextBoxWidthFraction(`rp-textbox-value-row3-${index}`,onInputElementDenValueChange,value,ansSegment)}}
                                                    value={denValues[ansSegment]?denValues[ansSegment]:""}
                                                    autoComplete="off"
                                                />
                                            }
                                        </td>;

            }else{
                tempColumn['row0'] = <td key={`rp-textbox-text-row0-${index}`}></td>;
                tempColumn['row1'] = <td key={`rp-textbox-text-row1-${index}`}></td>;
                tempColumn['row2'] = <td  key={`rp-textbox-text-row2-${index}`}>{React.createElement(MathJax,{className: "rp-ft-mathjax","math":ansSegment})}</td>;
                tempColumn['row3'] = <td key={`rp-textbox-text-row3-${index}`}></td>; 
            }

            data.push(tempColumn);
        
        }

        return data;
    }

    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(formula);
    // console.debug("formulaMap", formulaMap, formulaTextArray, signValues)
    const tableData = buildFractionTableData(formulaTextArray,formulaMap);
    

    
    
    if(formulaTextArray && formulaTextArray.length > 0 && formulaMap ){
        return <div style={{height:'200px'}}>
            <div className='mb-2'>Fill in the input boxes:</div>

        <div style={{width:"max-content"}} className={`rp-text-box position-relative ${showAnswerResponse ? (answerCorrect ? 'rp-text-box-correct' : 'rp-text-box-incorrect') : ''}`}> 
                <div  style={{
                    display:"flex",
                    alignItems:'center',
                    width:"max-content"
                }}> 
                        <div style={{fontSize:"14px",fontWeight:"500",whiteSpace:"nowrap"}}>
                                {formulaPrefix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaPrefix} /> : ''}                
                            </div> 
                        <table style={{marginLeft:"-7px"}}>
                        <tbody  className="rp-text-box-table-body">
                            <tr>
                            {
                                tableData.map(columnData=>{
                                    return columnData.row1
                                })
                            }
                            </tr>
                        
                            <tr>
                            {
                                tableData.map(columnData=>{
                                    return columnData.row3
                                })
                            }
                            </tr>
                           
                        </tbody>
                        </table>
                        <div style={{fontSize:"14px",fontWeight:"500",whiteSpace:"nowrap",marginLeft:"-2px"}}>
                                {formulaSuffix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaSuffix} /> : ''}                
                            </div> 
                </div>
            <div style={{display:"flex",alignItems:"center",justifyContent:"start",marginTop:"-13px"}}>
            <div style={{visibility: "hidden",fontSize:"14px",fontWeight:"500",whiteSpace:"nowrap"}}>
                                {formulaPrefix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaPrefix} /> : ''}                
             </div> 
            <table style={{marginLeft:"-10px"}}>
            <tbody  style={{textAlign:"center"}}>
                    <tr>
                                    {
                                        tableData.map(columnData=>{
                                            return columnData.row0
                                        })
                                    }
                                </tr>
                </tbody >
                </table>
            </div>
        </div>
      
        </div>
    }else{
        return null;
    }
   
}



const AnswerTypeRPTextBox = ({currentQuestionType, answer_formula,onAnswerChoice,showRPAnswer,currentVariableMap,questionID,answerFormat,onSubmit,onAnswerChoiceDetails, showAnswerResponse, answerCorrect, selectedAnswers, question_attempt, alreadyPickedAnswer }) => {
    const props = {currentQuestionType, answer_formula,onAnswerChoice,showRPAnswer,currentVariableMap,questionID,onSubmit,onAnswerChoiceDetails, showAnswerResponse, answerCorrect, selectedAnswers,answerFormat, question_attempt, alreadyPickedAnswer}
    
    if(answerFormat === 1  || answerFormat === 5 || answerFormat === 6){
        return <AnswerDecimalNotation {...props}></AnswerDecimalNotation>;
    }else if(answerFormat === 2){
        return <AnswerExpSciNotation {...props}></AnswerExpSciNotation>
    } else if (answerFormat === 4) {
        return <AnswerDecimalNotation {...props}></AnswerDecimalNotation>;
    }
    else{
        return <Fraction {...props}></Fraction>
    }
};

export default AnswerTypeRPTextBox; 